"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyHistory = void 0;
class PolicyHistory {
}
exports.PolicyHistory = PolicyHistory;
//# sourceMappingURL=PolicyHistory.js.map